import { TItem } from '../types/items.types';
import { TERMINOLOGY } from '@shared/i18n';

const getItemTypeLabel = (item: TItem) => {
  if (item.type === 'DOCUMENT') return 'document';
  if (item.type === 'FILE') return 'file';
  if (item.type === 'FOLDER') return 'folder';
  if (item.type === 'REPLICA_DOCUMENT' || item.type === 'REPLICA_FILE') return TERMINOLOGY.replica.lower;
  return 'item';
};

export default getItemTypeLabel;
